import {
  cachedFetch
} from '@remarkablenet/rcm-utils/cached-fetch';
import { FormDataObject } from '@remarkablenet/rcm-utils/form-to-json';
import { customSelectResetAll, customSelectUpdate } from '../custom-select/custom-select';
import { fetchJSON } from '../fetch-helper/fetch-helper';
import { previewQuickbasket } from '../quick-basket/quick-basket-ui';
import { displayToast } from '../toastify/toastify';
import { queryStringFromObject } from "../utility-functions/utility-functions";

const BASKET_URL = "/basket/api";
const QUICK_BASKET_URL = "/basket/quickbasket";
const UPDATE_BASKET_QTY = "/basket/quickbasket/updatequantity";
const UPDATE_BASKET_SIZE = "/basket/quickbasket/updatesizes";
const GET_BASKET_LENGTHS = "/basket/quickbasket/getlengths";
const GET_BASKET_SIZES = "/basket/quickbasket/getsizes";

const addMultipleProducts = (productArr, isInOffCanvasPanel?: boolean) => {
  const fetchArray = productArr.map((singleProduct) => {
    return addSingleProduct(singleProduct, isInOffCanvasPanel);
  });

  return Promise.all(fetchArray).catch((error) => {
    return { message: "error fetching adding or more products", errorResponse: error };
  });
};

const addSingleProduct = (singleProduct, isInOffCanvasPanel?: boolean) => {
  let url = `${BASKET_URL}/add?${queryStringFromObject(singleProduct)}`;

  if (!isInOffCanvasPanel && window.location.href.includes('s=googleshoppingppc')) {
    url += '&leadproduct=true';
  }

  return fetch(url, { credentials: "include" })
    .then((res) => res.json())
    .then((product) => {
      if (product.success === false) return { ...singleProduct, ...product };
      return product;
    })
    .catch((error) => {
      return { message: "server error", error };
    });
};

export const addGiftCard = (url?: string) => {

  const GiftCardForm = document.getElementById("GiftCardForm") as HTMLFormElement;
  const addBasketUrl = `${BASKET_URL}/add/`;

  if (GiftCardForm) {
    GiftCardForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      const data = new FormData(GiftCardForm);
      const queryParams = new URLSearchParams();
      const formObject: any = {};

      data.forEach((value, key) => {
        formObject[key] = value;
      });

      data.forEach((value, key) => {
        //@ts-ignore
        queryParams.append(key, value);
      });

      const queryString = queryParams.toString();
      let requestUrl = `${addBasketUrl}?${queryString}`;

      if (window.location.href.includes('s=googleshoppingppc')) {
        requestUrl += '&leadproduct=true';
      }

      try {
        const response = await fetch(requestUrl);

        if (response.ok) {
          const json = await response.json();

          if (json.success === true) {

            if (!json.success) displayToast(json.reason != null ? json.reason : json.message);
            else {

              if (document.querySelector('.quickbuy-panel')) document.querySelector('.quickbuy-panel').remove();

              previewQuickbasket();

              displayToast('Added to bag', {
                className: 'toastify-center typeography-apercu-mono font-regular px-lg-5',
                duration: 1500
              });

              resetGiftCard();
            }

          }
        }

      } catch (error) {
        console.log(error);
      }

    });
  }
};


const modifyBagItem = (productToModify) => {
  let url;

  typeof productToModify === "string" ? (url = productToModify) : (url = `${BASKET_URL}/${productToModify.action}?${queryStringFromObject(productToModify.product)}`);

  return fetch(url, { credentials: "include" })
    .then((resp) => resp.json())
    .then((response) => {
      if (response.success === false) return { ...productToModify, ...response };
      return response;
    })
    .catch((error) => {
      return { message: "server error", error };
    });
};

const modifyQuickBagItem = (productToModify) => {
  let url;

  typeof productToModify === "string" ? (url = productToModify) : (url = `${QUICK_BASKET_URL}/${productToModify.action}?${queryStringFromObject(productToModify.product)}`);

  return fetch(url, { credentials: "include" })
    .then((resp) => resp.json())
    .then((response) => {
      if (response.success === false) return { ...productToModify, ...response };
      return response;
    })
    .catch((error) => {
      return { message: "server error", error };
    });
};


export const modifyQty = (id, Qty) => {
  const url = `${UPDATE_BASKET_QTY}?basketLineId=${id}&quantity=${Qty}`;

  return fetch(url, { credentials: "include" })
    .then((resp) => resp.json())
    .then((response) => {
      if (response.success === false) return { ...response };
      return response;
    })
    .catch((error) => {
      return { message: "server error", error };
    });
};


export const handleSizeSelection = async (id, qty, length, size, parent) => {
  const url = `${UPDATE_BASKET_SIZE}?basketLineId=${id}&quantity=${qty}&length=${length}&size=${size}`;
  const response = fetchJSON(url);

  response.then(({ errors, succeeded }) => {
    if (errors.length) {
      displayToast(errors[0].description, {
        className: 'toastify-center typography-apercu-mono font-regular alert-danger',
        backgroundColor: "#d9534f",
        duration: 5000
      });

      parent.classList.add('custom-select--error');
    }

    if (succeeded) {
      parent.classList.remove('custom-select--error');
      parent.classList.add('selected');
      updateQuantityOptions();

      const urlParams = new URLSearchParams(url.split('?')[1]);
      const basketLineId = urlParams.get('basketLineId');

      const basketItem = document.querySelector(`.basket-item[data-basketlineid="${basketLineId}"]`);
      const basketLineExpanded = document.querySelector(`.basket-item[data-basketlineid="${basketLineId}"] .expanded`);

      if (basketItem) {
        const titleElement = basketItem.querySelector('.basket-item__title');
        const isShirt = titleElement && titleElement.textContent.toLowerCase().includes('shirt');

        let dynamicText = `Size: ${size}`;

        if (!isShirt || (length && length !== 'R' && length.toLowerCase() !== 'regular')) {
          if (length && length.length <= 2) {
            dynamicText += `${length}`;
          }
        }

        const dynamicSizing = basketItem.querySelector('.dynamic-sizing');
        if (dynamicSizing) {
          dynamicSizing.textContent = dynamicText;
        }
      }

      basketLineExpanded.classList.remove('expanded');

      displayToast("Size successfully updated", {
        className: 'toastify-center typography-apercu-mono font-regular',
        backgroundColor: '#28252c',
        style: {
          color: '#fff'
        },
        duration: 2000
      });
    }
  });
};



export const handleLengthSelection = async (gid, selectorValue, parent) => {
  const options = document.querySelectorAll<HTMLElement>(`[data-gid="${gid}"]:not([data-name="Length"]):not([data-name="Qty"])`);
  const selectedOption = document.querySelector<HTMLElement>(`[data-gid="${gid}"][data-name="${selectorValue}"]`);
  options.forEach((option) => {
    option.classList.add('d-none');
  });

  selectedOption.classList.remove('d-none');
  parent.classList.add('selected');
  parent.closest('.basket-items__sizing').querySelector('[data-type="size"]:not(.d-none)').classList.add('custom-select--error');
  updateQuantityOptions();
  unselectSizeOption(selectedOption);
}

export interface IAddToBagParams {
  price?: number;
  productId: string;
  stockId: string;
  quantity: number;
}
// Add to bag
export const addToBag = (productToAdd: JSON | FormDataObject | IAddToBagParams | Array<IAddToBagParams>, isInOffCanvasPanel?: boolean) => {
  if (Array.isArray(productToAdd)) return addMultipleProducts(productToAdd, isInOffCanvasPanel);
  return addSingleProduct(productToAdd, isInOffCanvasPanel);
};

// Below methods can take productID or full url as an argument.

// Remove from bag
export const removeFromBag = (productId) => {
  const query = typeof productId === "string" ? productId : { action: "delete", product: { basketLineId: productId } };
  return modifyBagItem(query);
};

// Increase quantity
export const increaseQuantity = (productId, quantity: number = null) => {
  const query = typeof productId === "string" ? productId : { action: "increase", product: { shoppingBasketId: productId, quantity: quantity ? quantity : 1 } };
  return modifyBagItem(query);
};

// Increase quantity basket
export const increaseQuantityBasket = (productId, quantity: number = null) => {
  const query = typeof productId === "string" ? productId : { action: "increase", product: { basketLineId: productId, quantity: quantity ? quantity : 1 } };

  return modifyQuickBagItem(query);
};

// Decrease quantity
export const decreaseQuantity = (productId, quantity: number = null) => {
  const query = typeof productId === "string" ? productId : { action: "decrease", product: { shoppingBasketId: productId, quantity: quantity ? quantity : 1 } };
  return modifyBagItem(query);
};

// Decrease quantity basket
export const decreaseQuantityBasket = (productId, quantity: number = null) => {
  const query = typeof productId === "string" ? productId : { action: "decrease", product: { basketLineId: productId, quantity: quantity ? quantity : 1 } };
  return modifyQuickBagItem(query);
};

// Get current bag
export const getCurrentBagData = (cacheBuster: boolean = false) => {
  return cachedFetch({
    url: `${BASKET_URL}/getcurrent`,
    options: {
      request: { credentials: 'include' },
      cacheBuster,
      seconds: 60
    }
  })
    .then((resp) => resp.json())
    .then((bag) => bag)
    .catch((error) => {
      return { message: 'server error', error };
    });
};



export const resetGiftCard = () => {
  const textInputs = document.querySelectorAll('.gc-input') as NodeListOf<HTMLInputElement>;
  const btn = document.querySelector('.js-add-giftcard-to-bag') as HTMLElement;

  setTimeout(() => {
    customSelectResetAll();

    textInputs.forEach((input) => {
      input.value = '';
    });

    btn.setAttribute('disabled', 'disabled');

  }, 1000);
};


export const updateQuantityOptions = () => {
  document.querySelectorAll<HTMLElement>('.custom-select[data-name="Qty"]').forEach((element) => {
    const basketid = element.getAttribute('data-id');
    fetch('/basket/getquantity?basketID=' + basketid, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      }
    })
      .then((response) => response.json())
      .then((data) => {
        element.querySelectorAll<HTMLElement>('li').forEach(li => {
          (+li.getAttribute('data-value') > +data) ? li.classList.add('d-none') : li.classList.remove('d-none');
        });
      })
      .catch((error) => {
        console.error(error);
      });
  });
}

export const unselectSizeOption = (selectedOption) => {
  customSelectUpdate(selectedOption, '--');
};
